import {Box, Typography} from "@mui/material";
import Row from "../../../../Common/Row";
import Column from "../../../../Common/Column";
import React from "react";

export const FloatingTag = ({discount, bgColor}) => {
    return (
        <Box sx={{
            // The price card itself
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "fit-content",
            minHeight: "31px",
            padding: "5px 15px 5px 25px",
            position: "absolute",
            top: "-20px",
            right: "-60px",
            borderRadius: "10px",
            background: "#fff",
            boxShadow: "4px 4px 2px -2px rgba(20,102,20,.3)",
            transform: "rotate(-30deg)",
            zIndex: "1",

            // The triangle
            "&::before": {
                content: "''",
                width: "34px",
                height: "34px",
                transform: " rotate(-45deg)",
                position: "absolute",
                left: "-10px",
                borderRadius: "10px",
                background: "#fff",
            },

            // The cut-out circle
            "&::after": {
                content: "''",
                width: "12px",
                height: "12px",
                borderRadius: "100%",
                position: "absolute",
                background: bgColor,
                left: "0px",
                boxShadow: "inset 2px 2px 2px rgba(20,102,20,.3)",
            }
        }}>
            {/* The content of the price card */}
            <Row sx={{
                alignItems: "center",
                zIndex: "1",
            }}>
                <Column>
                    <Typography sx={{
                        color: "#545454",
                        fontSize: "22px",
                        lineHeight: "0.9",
                    }}>
                        Spar
                    </Typography>
                    <Typography sx={{
                        lineHeight: "0.9",
                        fontSize: "30px",
                        color: "#545454",
                        height: "fit-content",
                        fontWeight: "bold",
                    }}>{discount}%</Typography>
                </Column>
            </Row>
        </Box>
    );
}